import { HeaderType } from '../Header/consts';

export const container = ({
    logoColors: { background, border },
    theme: { colors, dimensions, transition },
    headerType,
}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    background: background || colors.blue,

    transition,
    transitionProperty: 'background, border-color',

    border: `1px solid ${border || colors.blue}`,

    paddingLeft: '1rem',
    paddingRight: '1rem',

    boxSizing: 'border-box',

    height: dimensions.headerHeight,

    tabletLarge: {
        height: dimensions.headerTabletHeight,
        paddingLeft: headerType === HeaderType.CASE_STUDY ? '1rem' : '2.7rem',
        paddingRight: '2.7rem',
        alignItems: 'flex-end',
    },

    pointerEvents: 'all',
});

export const logo = ({ logoColors: { text }, theme: { colors, transition }, headerType }) => ({
    width: '11.1rem',
    height: '2.85rem',

    fill: text || colors.white,

    transition,
    transitionProperty: 'fill',

    tabletLarge: {
        width: '100%',
        height: '3.5625rem',
    },
});

export const link = () => ({
    lineHeight: 0,
});
